var _style, _polygon, _path, _path2, _path3, _path4, _path5, _polygon2, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRakutenTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 186.5 42",
    style: {
      enableBackground: "new 0 0 186.5 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BF0000;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "111.3,35.3 27.6,35.3 34.3,42 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,8.4v1c-1.6-1-2.9-1.6-4.9-1.6c-5.9,0-10.3,5.3-10.3,11.9c0,6.6,4.5,11.9,10.3,11.9c1.9,0,3.3-0.6,4.9-1.6 v1h5.1V8.4H35.4z M30.5,26.2c-2.9,0-5-2.8-5-6.4c0-3.6,2.1-6.4,5-6.4c2.9,0,4.9,2.8,4.9,6.4C35.5,23.3,33.4,26.2,30.5,26.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.6,8.4v13.3c0,2.5-1.7,4.6-4.2,4.6c-2.5,0-4.2-2.1-4.2-4.6V8.4h-5.2v13.3c0,5.5,3.7,9.9,9.2,9.9 c2.5,0,4.4-1.4,4.4-1.4v0.8h5.1V8.4H76.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.6,31.1V17.7c0-2.5,1.7-4.6,4.2-4.6c2.5,0,4.2,2.1,4.2,4.6v13.3h5.2V17.7c0-5.5-3.7-9.9-9.2-9.9 c-2.5,0-4.4,1.4-4.4,1.4V8.4h-5.1v22.7H124.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.4,31.1v-8.8h3.8l6.6,8.8h6.7l-8-10.6c2.5-1.8,4.1-4.7,4.1-8c0-5.4-4.4-9.8-9.8-9.8H0v28.3H5.4z M5.4,8.1h3.5 c2.4,0,4.4,2,4.4,4.4c0,2.4-2,4.4-4.4,4.4H5.4V8.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.7,25.7c-0.5,0.3-1,0.6-1.7,0.6c-0.8,0-2.4-0.6-2.4-2.8v-9.7h4.4V8.4h-4.4l0-5.7h-5.1l0,5.7h-2.7v5.4h2.7 v9.8c0,5.1,3.8,8.1,7.7,8.1c1.4,0,3.4-0.5,5-1.4L95.7,25.7z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "53.3,19 62.2,8.4 55,8.4 48.8,16.3 48.8,0.9 43.5,0.9 43.5,31.1 48.8,31.1 48.8,21.8 56.4,31.1  63.6,31.1 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.6,7.8c-6,0-10.2,5.2-10.2,11.9c0,7,5.4,11.9,10.7,11.9c2.7,0,6.2-0.9,9.1-5.1l-4.5-2.6 c-3.5,5.2-9.4,2.6-10.1-2.6l14.8,0C118.7,13.2,113.4,7.8,107.6,7.8z M112.1,16.8h-9.3C103.9,11.5,111.1,11.2,112.1,16.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.1,10.7c-0.1-0.9-0.1-1.3,0.6-1.7c0.5-0.3,3-1.8,7.7-3.2c0.6-0.2,1.1-0.1,1.4,0.3c0.3,0.4,0.4,1,0.2,1.5 c-0.4,1-0.5,1.8-0.1,2.2c0.4,0.3,0.8,0.4,2-0.2c1.6-0.8,3.4-2.9,3.3-6.3c0-1.2-0.5-2.1-1.3-2.7c-0.8-0.5-1.9-0.7-3-0.7 c-3,0-4.5,0.7-8.4,2.2c-5.5,2-12.4,4.2-16.2,5.2c-1.6,0.4-2.9,1.5-2.9,3.1c0,2.5,3,3.2,5.1,2.5c0.4-0.1,4.7-1.7,6.2-1.9 c0.2,0,0.3,0.1,0.3,0.2c0,0.2,0.1,2.4,0.2,3.3c0.2,4.1,0.5,12.1,0.5,12.6c0.1,1.1,0.1,4.4,1.9,4.4c1.7,0,2.5-1.8,2.9-4.4 c0.6-3.7,0.1-8.9-0.1-13.1C162.3,13,162.1,10.7,162.1,10.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.7,4.1c-2.3,0-4.4,4.2-6,7.9c-2,4.7-3.1,8.9-3.7,10.3c-0.5-1.4-1.9-5.4-2.6-6.8c-1.2-2.5-2.4-4.4-4-4.4 c-0.9,0-1.9,0.5-1.9,2.1c0,1.1,0.5,2.5,1,3.8c0.2,0.4,3.2,7.8,3.6,9.2c0,0,1.5,4.5,1.6,4.9c0.9,2.7,1.7,3,2.3,3 c0.9,0,2.2-0.4,2.8-3.1c0.4-1.7,1-3.7,1.5-5.4c0.9-2.9,3.1-8.5,4.6-11.9c1.2-2.7,2.6-5.9,2.6-7.9C186.5,5.1,186.1,4.1,184.7,4.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRakutenTv);
export default __webpack_public_path__ + "static/media/Rakuten_TV.ae10908966b9f5f6b06760466c5b7f39.svg";
export { ForwardRef as ReactComponent };